var map = {
	"./Server-Busy.None.svg": 2968,
	"./Server-Busy.OfflineDrop.svg": 2969,
	"./Server-Busy.Ssh.svg": 2970,
	"./Server-Busy.TentacleActive.svg": 2971,
	"./Server-Busy.TentaclePassive.svg": 2972,
	"./Server-CalamariNeedsUpgrade.Ssh.svg": 2973,
	"./Server-CalamariNeedsUpgrade.TentacleActive.svg": 2974,
	"./Server-CalamariNeedsUpgrade.TentaclePassive.svg": 2975,
	"./Server-Default.AzureCloudService.svg": 2976,
	"./Server-Default.AzureServiceFabricCluster.svg": 2977,
	"./Server-Default.AzureSubscription.svg": 2978,
	"./Server-Default.AzureWebApp.svg": 2979,
	"./Server-Default.Kubernetes.svg": 2980,
	"./Server-Default.None.svg": 2981,
	"./Server-Default.OfflineDrop.svg": 2982,
	"./Server-Default.Ssh.svg": 2983,
	"./Server-Default.TentacleActive.svg": 2984,
	"./Server-Default.TentaclePassive.svg": 2985,
	"./Server-Disabled.AzureCloudService.svg": 2986,
	"./Server-Disabled.AzureServiceFabricCluster.svg": 2987,
	"./Server-Disabled.AzureSubscription.svg": 2988,
	"./Server-Disabled.AzureWebApp.svg": 2989,
	"./Server-Disabled.Kubernetes.svg": 2990,
	"./Server-Disabled.None.svg": 2991,
	"./Server-Disabled.OfflineDrop.svg": 2992,
	"./Server-Disabled.Ssh.svg": 2993,
	"./Server-Disabled.TentacleActive.svg": 2994,
	"./Server-Disabled.TentaclePassive.svg": 2995,
	"./Server-HasWarnings.Ssh.svg": 2996,
	"./Server-HasWarnings.TentacleActive.svg": 2997,
	"./Server-HasWarnings.TentaclePassive.svg": 2998,
	"./Server-Healthy.AzureCloudService.svg": 2999,
	"./Server-Healthy.AzureServiceFabricCluster.svg": 3000,
	"./Server-Healthy.AzureSubscription.svg": 3001,
	"./Server-Healthy.AzureWebApp.svg": 3002,
	"./Server-Healthy.Kubernetes.svg": 3003,
	"./Server-Healthy.None.svg": 3004,
	"./Server-Healthy.OfflineDrop.svg": 3005,
	"./Server-Healthy.Ssh.svg": 3006,
	"./Server-Healthy.TentacleActive.svg": 3007,
	"./Server-Healthy.TentaclePassive.svg": 3008,
	"./Server-NeedsUpgrade.TentacleActive.svg": 3009,
	"./Server-NeedsUpgrade.TentaclePassive.svg": 3010,
	"./Server-Unavailable.AzureCloudService.svg": 3011,
	"./Server-Unavailable.AzureServiceFabricCluster.svg": 3012,
	"./Server-Unavailable.AzureSubscription.svg": 3013,
	"./Server-Unavailable.AzureWebApp.svg": 3014,
	"./Server-Unavailable.Kubernetes.svg": 3015,
	"./Server-Unavailable.OfflineDrop.svg": 3016,
	"./Server-Unavailable.Ssh.svg": 3017,
	"./Server-Unavailable.TentacleActive.svg": 3018,
	"./Server-Unavailable.TentaclePassive.svg": 3019,
	"./Server-Unhealthy.AzureCloudService.svg": 3020,
	"./Server-Unhealthy.AzureServiceFabricCluster.svg": 3021,
	"./Server-Unhealthy.AzureWebApp.svg": 3022,
	"./Server-Unhealthy.Kubernetes.svg": 3023,
	"./Server-Unhealthy.OfflineDrop.svg": 3024,
	"./Server-Unhealthy.Ssh.svg": 3025,
	"./Server-Unhealthy.TentacleActive.svg": 3026,
	"./Server-Unhealthy.TentaclePassive.svg": 3027,
	"./Server-Unknown.AzureCloudService.svg": 3028,
	"./Server-Unknown.AzureServiceFabricCluster.svg": 3029,
	"./Server-Unknown.AzureSubscription.svg": 3030,
	"./Server-Unknown.AzureWebApp.svg": 3031,
	"./Server-Unknown.Kubernetes.svg": 3032,
	"./Server-Unknown.None.svg": 3033,
	"./Server-Unknown.OfflineDrop.svg": 3034,
	"./Server-Unknown.Ssh.svg": 3035,
	"./Server-Unknown.TentacleActive.svg": 3036,
	"./Server-Unknown.TentaclePassive.svg": 3037,
	"./Server-Warning.OfflineDrop.svg": 3038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2967;